/** TTL do cache no backend (segundos) — espelha CACHE_TTL_SECONDS nas rotas */
const DEFAULT_CACHE_TTL_MS = 10 * 60 * 1000;

const extractCacheMeta = (response, ttlMs = DEFAULT_CACHE_TTL_MS) => {
  const expiresAtRaw = response?.headers?.['x-cache-expires-at'];
  if (!expiresAtRaw) return null;

  const expiresAt = new Date(expiresAtRaw);
  if (Number.isNaN(expiresAt.getTime())) return null;

  const calculatedAt = new Date(expiresAt.getTime() - ttlMs);

  return {
    expiresAt,
    calculatedAt,
    status: response?.headers?.['x-cache'],
  };
};

const mergeCacheMeta = (current, incoming) => {
  if (!incoming) return current;
  if (!current) return incoming;

  return {
    calculatedAt:
      incoming.calculatedAt < current.calculatedAt
        ? incoming.calculatedAt
        : current.calculatedAt,
    expiresAt:
      incoming.expiresAt > current.expiresAt ? incoming.expiresAt : current.expiresAt,
    status: incoming.status,
  };
};

export { DEFAULT_CACHE_TTL_MS, extractCacheMeta, mergeCacheMeta };
